<template>
  <div>
    
<FormKitLazyProvider config-file="true">
<div class="max-w-screen-tablet">
      <div v-if="isSuccess">
        <h3 v-if="successTitle" class="title is-h3">{{ successTitle }}</h3>
        <div v-if="successMessage" class="ck-content" v-html="successMessage" />
      </div>
      <FormKitWebform
        v-else
        v-bind="webform"
        :submit-form="submitForm"
        form-class="grid"
        @success="onSuccess"
      />
    </div>
</FormKitLazyProvider>

  </div>
</template>

<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
import type {
  WebformSubmissionResultFragment,
  WebformFragment,
  SubmitWebformMutationVariables,
} from '#graphql-operations'
import type { MutationVariables } from '~/layers/webform-formkit/types/webform'

const props = defineProps<{
  webform: WebformFragment
  sourceEntityId?: string
  sourceEntityType?: string
}>()

const { $texts } = useEasyTexts()

const isSuccess = ref(false)

async function submitForm(
  input: MutationVariables,
): Promise<WebformSubmissionResultFragment> {
  if (!props.webform?.id) {
    throw new Error('Missing webform ID')
  }
  const elements = input.elements.map((v) => {
    return {
      element: v.element,
      value: v.value,
    }
  })

  const files = input.files.map((v) => {
    return {
      element: v.element,
      file: v.value,
    }
  })

  const variables: SubmitWebformMutationVariables = {
    id: props.webform.id,
    elements,
    files,
    sourceEntityType: props.sourceEntityType,
    sourceEntityId: props.sourceEntityId,
  }

  const { data, errors } = await useGraphqlUploadMutation(
    'submitWebform',
    variables,
  )

  if (!data || errors?.length) {
    throw new Error('Failed to submit webform.')
  }

  return data.submitWebform
}

const successTitle = computed(() => props.webform.confirmation?.title)
const successMessage = computed(
  () =>
    props.webform.confirmation?.message ||
    $texts('webform.successText', 'Submission successful'),
)

function onSuccess() {
  isSuccess.value = true
}
</script>

<style lang="postcss">
.formkit-section {
  margin: 2.375rem 0;
  padding: 2.375rem 0;
  border-bottom: 2px solid #000;
  border-top: 2px solid #000;
}

.formkit-section + .formkit-section {
  border-top: 0;
  margin-top: 0;
  padding-top: 0;
}

.formkit-section-title {
  @apply text-scheme-invert font-bold;
  margin-bottom: 0.75em;
}

.formkit-actions {
  @apply border-t border-solid border-border;
  padding: 1rem 0;
}

.formkit-flexbox {
  @apply tablet:flex;
  margin: 0 -0.5rem;

  & .formkit-outer {
    flex: 1;
    padding: 0 0.5rem;
  }
}
</style>
